module.exports = __webpack_public_path__ + "static/media/staysafe.c7296e17.png";